import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { MenuSettingsState } from '@layout/left-panel/store/states/menu-settings.state';
import { LoadMenuSettings, LoadMenuSettingsIfNotLoaded, UpdateMenuSettings } from '@layout/left-panel/store/actions/menu-settings.actions';

@Injectable({
  providedIn: 'root',
})
export class MenuSettingsFacade {
  private readonly store = inject(Store);

  readonly isMenuCollapsed = this.store.selectSignal(MenuSettingsState.isMenuCollapsed);
  readonly areMenuSettingsLoaded = this.store.selectSignal(MenuSettingsState.isLoaded);

  loadMenuSettings(): void {
    this.store.dispatch(new LoadMenuSettings());
  }

  loadMenuSettingsIfNotLoaded(): void {
    this.store.dispatch(new LoadMenuSettingsIfNotLoaded());
  }

  updateMenuSettings(isMenuCollapsed: boolean): void {
    this.store.dispatch(new UpdateMenuSettings(isMenuCollapsed));
  }
}
